import { Axios } from "../../../util";
import axios from "axios";

const getMenuSettingAPI = async (role) => {
  try {
    const res = await Axios.get(`/api/parameter/getMenuSetting?role=${role}`);
    
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const getRoleMaintenanceAPI = async (roleName) => {
  try {
    const res = await Axios.get(`/api/parameter/getRoleMaintenance?roleName=${roleName}`);
    
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const saveRole = async (editData) => {
  try {
    const res = await Axios.post('/api/parameter/saveRole', editData);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const updateRole = async (editData) => {
  try {
    const res = await Axios.post('/api/parameter/updateRole', editData);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const saveMenuSetting = async (editData) => {
  try {
    const res = await Axios.post('/api/parameter/saveMenuSetting', editData);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};


export { getMenuSettingAPI,
         getRoleMaintenanceAPI,
         saveRole,
         updateRole,
         saveMenuSetting
          };
